export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    favicon.href = favicon.dataset.badgeHref || '/brand-assets/logo_badge.svg';
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        favicon.href =
          favicon.dataset.defaultHref || '/brand-assets/logo_thumbnail.svg';
      });
    }
  });
};
